import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Sprawdź dostępność adresu',
  or: 'lub',
  form: {
    company: {
      label: 'Wybierz restaurację',
    },
    address: {
      label: 'Wpisz adres',
    },
  },
  result: {
    positive: '{{address}} jest objęty dostawą zewnętrzną',
    negative: '{{address}} nie jest objęty dostawą zewnętrzną',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Sprawdź',
  },
  toasts: {
    error: 'Nie udało się sprawdzić dostępności adresu',
  },
};
